import { GalleryOptions_Layout_Type as GALLERY_LAYOUT } from "./../ricos-schema/legacy/wix/rich_content/v1";
const GALLERY_ITEMS_TYPES = Object.freeze({
  IMAGE: "image",
  VIDEO: "video"
});
const DEFAULTS = Object.freeze({
  items: [],
  options: {
    layout: {
      type: GALLERY_LAYOUT.GRID,
      orientation: "COLUMNS",
      horizontalScroll: true,
      numberOfColumns: 3
    },
    item: {
      crop: "FILL",
      ratio: 1
    }
  },
  containerData: {
    alignment: "CENTER",
    width: {
      size: "CONTENT"
    }
  }
});
const LAYOUT_FIXED_STYLES = {
  [GALLERY_LAYOUT.COLLAGE]: {
    galleryType: "Columns",
    imageMargin: 5
  },
  [GALLERY_LAYOUT.MASONRY]: {
    imageMargin: 5,
    isVertical: false,
    gridStyle: 0
  },
  [GALLERY_LAYOUT.GRID]: {
    imageResize: false,
    gridStyle: 1,
    galleryImageRatio: 2,
    imageMargin: 5
  },
  [GALLERY_LAYOUT.THUMBNAIL]: {
    arrowsSize: 23,
    thumbnailSize: 120,
    floatingImages: 0
  },
  [GALLERY_LAYOUT.SLIDER]: {
    arrowsSize: 23,
    imageMargin: 5
  },
  [GALLERY_LAYOUT.SLIDESHOW]: {
    arrowsSize: 23,
    floatingImages: 0,
    slideshowInfoSize: 0
  },
  [GALLERY_LAYOUT.PANORAMA]: {
    hasThumbnails: false,
    imageMargin: 5
  },
  [GALLERY_LAYOUT.COLUMN]: {
    arrowsSize: 23,
    hasThumbnails: false,
    imageMargin: 5
  },
  [GALLERY_LAYOUT.FULLSIZE]: {
    arrowsSize: 23,
    floatingImages: 0,
    slideshowInfoSize: 0
  },
  [GALLERY_LAYOUT.MAGIC]: {
    imageResize: false,
    gridStyle: 1,
    galleryImageRatio: 2,
    imageMargin: 5
  },
  [GALLERY_LAYOUT.UNRECOGNIZED]: {
    imageResize: false,
    gridStyle: 1,
    galleryImageRatio: 2,
    imageMargin: 5
  }
};
const FIXED_STYLES = {
  gallerySizeType: "px",
  enableInfiniteScroll: true,
  titlePlacement: "SHOW_ON_HOVER",
  hoveringBehaviour: "NO_CHANGE",
  alwaysShowHover: true,
  allowHover: true,
  itemClick: "link",
  fullscreen: false,
  loveButton: false,
  allowSocial: false,
  allowDownload: false,
  mobileSwipeAnimation: "NO_EFFECT",
  gotStyleParams: true,
  videoPlay: "CLICK",
  videoLoop: false,
  videoSound: true,
  hidePlay: false,
  showVideoPlayButton: true,
  showVideoControls: true
};
const getFixedStyles = (layout) => {
  return { ...FIXED_STYLES, ...LAYOUT_FIXED_STYLES[layout] };
};
export {
  DEFAULTS,
  GALLERY_ITEMS_TYPES,
  getFixedStyles
};
//# sourceMappingURL=defaults.js.map
